import { Trans } from '@lingui/macro'

import * as React from 'react'

type TProps = NoChildren & {
  /**
   * is product combination meal or not
   */
  isCombinationMeal: boolean
  formattedPrice: string
}

/**
 * If product is a combination meal, add "From" in front of price.
 */
export const ProductPrice: React.FC<TProps> = ({ isCombinationMeal, formattedPrice }) => {
  if (!isCombinationMeal) return formattedPrice

  return (
    <>
      <Trans comment={`from 250 Kč.`}>from</Trans> {formattedPrice}
    </>
  )
}
